import { ErrorMessage } from '../constants/ErrorMessage';
import MessageHelper from '../helpers/MessageHelper';
import { Result } from '../models/Result';

export default class GetItemByIntegerIdViewModel {
    private id: number = 0;

    public constructor() {}

    public getId() {
        return this.id;
    }

    public setId(id?: number | null) {
        if (id) {
            this.id = id;
        }
    }

    public validate() {
        const result = new Result();
        if (this.id <= 0) {
            result.message = MessageHelper.format(ErrorMessage.INVALID_PARAMETER, 'id');
            return result;
        }

        result.success = true;
        return result;
    }
}
